// extracted by mini-css-extract-plugin
export default {"country_item":"styled_country_item__sZpKU"};